import React from 'react';
import styled from '@emotion/styled';

const Frame = styled.div({
    pointerEvents: 'none',
    width: '100%',
    height: '100%',
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'space-between',
});

const Upper = styled.div({
    flexGrow: 0,
    flexShrink: 0,
});

const Lower = styled.div({
    flexGrow: 3,
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'space-between',
});

type TopProps = {
    n: number;
}

const Top = styled.div<TopProps>(props => ({
    width: '100%',
    display: 'flex',
    flexDirection: 'row',
    justifyContent: props.n > 1 ? 'space-between' : 'center',
    ['> *']: {
        pointerEvents: 'auto',
    },
}));

const Side = styled.div({
    height: '100%',
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'flex-end',
    ['> *']: {
        pointerEvents: 'auto',
    },
});

export type AnchorLayoutProps = {
    className?: string;
    anchors: {
        top: JSX.Element[];
        left: JSX.Element[];
        right: JSX.Element[];
    };
}

export const AnchorLayout = (props: AnchorLayoutProps) => {
    return (
        <Frame className={props.className}>
            <Upper>
                <Top n={props.anchors.top.length}>
                    {
                        props.anchors.top
                    }
                </Top>
            </Upper>
            <Lower>
                <Side>
                    {
                        props.anchors.left
                    }
                </Side>
                <Side>
                    {
                        props.anchors.right
                    }
                </Side>
            </Lower>
        </Frame>
    );
};
